import React from "react"

import { 
    CareerPathButtonContainer,
    CareerPathButtonText,
    DefaultIcon,
    HoverIcon,
    WhiteChevron,
    BlueChevron
} from "./career-path-button.styles"

export const CareerPathButton = ({svg, svgHover, title, link}) => {

    return (
        <CareerPathButtonContainer 
            href={link}
            internal
            >
            <DefaultIcon><img src={svg} alt={title} /></DefaultIcon>
            <HoverIcon><img src={svgHover} alt={title} /></HoverIcon>     
            <CareerPathButtonText>{title}</CareerPathButtonText>
            <WhiteChevron />
            <BlueChevron />
        </CareerPathButtonContainer>
    )
}